import { render } from "./UnknownBlock.vue?vue&type=template&id=7ef08733"
import script from "./UnknownBlock.vue?vue&type=script&lang=js"
export * from "./UnknownBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__